{
  "sidenavMenuCloseTooltip": "Close menu",
  "sidenavMenuLockTooltip": "Click to lock menu",
  "toggleSideNav": "Toggle side navigation menu"
}
